import { useState } from "react"
import { Row, Col } from "../../ui/ot"
import GoogleTranslate from "../components/google_translate"

const Header = ({ information, imageFileData = [] }) => {
    const [logoError, setLogoError] = useState(false)
    const [defaultLogoError, setDefaultLogoError] = useState(false)

    const renderLogoImage = (imageFileDatas) => {
        const LogoImageFileData = imageFileDatas?.find((ele) => ele?.title === "Logo")
        const classifyStructureTypeFileData = LogoImageFileData?.classify_structure_type_file_data || []

        const fallbackText = () => {
            const nameLanguageData = information?.name_language_data || []
            const showNameData = nameLanguageData.find(
                (ele) => ele?.language_culture_code === "zh-tw"
            )
            return showNameData?.language_culture_value || "Logo"
        }

        const imageClass =
            "h-auto max-h-[40px] sm:max-h-[50px] lg:max-h-[60px] transition-all duration-300 hover:scale-105"

        if (classifyStructureTypeFileData.length > 0 && !logoError) {
            return classifyStructureTypeFileData.map((file) => (
                <a href="/officialweb/frontend" key={file.file_id} className="inline-block">
                    <img
                        className={imageClass}
                        src={file?.file_url}
                        alt="Logo"
                        onError={() => setLogoError(true)}
                    />
                </a>
            ))
        }

        if (!defaultLogoError) {
            return (
                <a href="/officialweb/frontend" className="inline-block">
                    <img
                        className={imageClass}
                        src="/afatsLib_logo.jpeg"
                        alt="Default Logo"
                        onError={() => setDefaultLogoError(true)}
                    />
                </a>
            )
        }

        return (
            <a href="/officialweb/frontend" className="inline-block">
                <div className="text-lg font-bold text-blue-800">{fallbackText()}</div>
            </a>
        )
    }

    return (
        <header className="sticky top-0 z-50 w-full bg-white shadow-md transition-shadow duration-300">
            {/* Desktop Header */}
            <div className="hidden lg:block">
                <Row
                    justify="space-between"
                    align="middle"
                    wrap
                    gutter={[0, 14]}
                    className="max-w-screen-xl mx-auto px-4 py-3"
                >
                    <Col className="flex items-center max-w-[20vw]">
                        {renderLogoImage(imageFileData)}
                    </Col>
                    <Col className="flex items-center ml-auto">
                        <GoogleTranslate />
                    </Col>
                </Row>
            </div>

            {/* Mobile Header */}
            <div className="block lg:hidden border-b border-gray-200 px-4 py-2">
                <Row justify="space-between" align="middle" wrap gutter={[0, 14]}>
                    <Col className="flex items-center">
                        {renderLogoImage(imageFileData)}
                    </Col>
                    <Col className="flex items-center ml-auto">
                        <GoogleTranslate />
                    </Col>
                </Row>
            </div>
        </header>
    )
}

export default Header
